import {
  Select, Option, Image, Input, Button, Dialog, Row, Col, Menu, MenuItem, Link, Radio,
  RadioGroup, RadioButton, Form, FormItem, Table, TableColumn, Avatar, Carousel, CarouselItem, Tag, Upload,
  DatePicker, Pagination, Checkbox, CheckboxGroup
} from 'element-ui'
import { message } from '../utils/message'
const element = {
  install: function (Vue) {
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Image)
    Vue.use(Input)
    Vue.use(Button)
    Vue.use(Dialog)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Menu)
    Vue.use(MenuItem)
    Vue.use(Link)
    Vue.use(Radio)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Avatar)
    Vue.use(Carousel)
    Vue.use(CarouselItem)
    Vue.use(Tag)
    Vue.use(Upload)
    Vue.use(DatePicker)
    Vue.use(Pagination)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.prototype.$message = message
  }
}
export default element


// WEBPACK FOOTER //
// ./theme/theme.js